import styled from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';
import SelectableButtonComponent from '../../../../components/selectable-button';

export const VariantGroupWrapper = styled.div`
  max-width: calc(100vw - ${remCalc(layout.pageContent.gutter.value * 2)});

  ${media.smallOnly`
    margin: 0 -${layout.pageContent.gutter.rem};
    overflow-x: auto;
  `};
`;

export const VariantGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 2px;

  ${media.smallOnly`
    margin: 0;
    padding: 0;
    padding-bottom: 2px;
    flex-wrap: nowrap;
    > :first-child {
      margin-left: ${layout.measurements.spacingSmall};
    }

    > :last-child {
      margin-right: ${layout.measurements.spacingSmall};
    }
  `}
`;

type SelectableButtonProps = {
  selected: boolean;
};

export const SelectableButton = styled(SelectableButtonComponent)<
  SelectableButtonProps
>`
  display: flex;
  min-width: 125px;
  min-height: 53px;
`;
